import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Step1Customer from './Step1Customer';
import Step2Subscription from './Step2Subscription';
import Step3CourseFamily from './Step3CourseFamily';
import Step4Course from './Step4Course';
import Step5Sessions from './Step5Sessions';
import Step6Sponsors from './Step6Sponsors';
import Step7Summary from './Step7Summary';
import ClassConfirmation from './ClassConfirmation';

const ClassWizard = () => {
  return (
    <Routes>
      <Route index element={<Navigate to="step1" replace />} />
      <Route path="step1" element={<Step1Customer />} />
      <Route path="step2" element={<Step2Subscription />} />
      <Route path="step3" element={<Step6Sponsors />} />
      <Route path="step4" element={<Step3CourseFamily />} />
      <Route path="step5" element={<Step4Course />} />
      <Route path="step6" element={<Step5Sessions />} />
      <Route path="step7" element={<Step7Summary />} />
      <Route path="confirmation" element={<ClassConfirmation />} />
      <Route path="*" element={<Navigate to="step1" replace />} />
    </Routes>
  );
};

export default ClassWizard; 